var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgOpenLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9286 6.25C14.52 6.25 15 6.81 15 7.5V18.75C15 19.44 14.52 20 13.9286 20H1.07143C0.48 20 0 19.44 0 18.75V7.5C0 6.81 0.48 6.25 1.07143 6.25H10V5.25C10 2.3505 12.2386 0 15 0C17.7614 0 20 2.3505 20 5.25V6.25H18.75V5.45C18.75 3.1304 17.0711 1.25 15 1.25C12.9289 1.25 11.25 3.1304 11.25 5.45V6.25H13.9286ZM1.25 18.75H13.75V7.5H1.25V18.75ZM8.74712 14.1181L9.375 15.625H5.625L6.25288 14.1181C5.86768 13.7517 5.625 13.2184 5.625 12.625C5.625 11.521 6.465 10.625 7.5 10.625C8.535 10.625 9.375 11.521 9.375 12.625C9.375 13.2184 9.13232 13.7517 8.74712 14.1181Z",
    fill: "#3D82F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLock);
export default __webpack_public_path__ + "static/media/OpenLock.29663ab2461d3aee6858ef0bdde9a041.svg";
export { ForwardRef as ReactComponent };